'use client';
const defaultStylesParams = {
    transitionDuration: 200,
    variant: 'default',
    radius: 56,
    size: 'xxs1'
};

export { defaultStylesParams };
//# sourceMappingURL=defaults.js.map
